// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { ShareOptions } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import translate from "@insite/client-framework/Translate";
// import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels"; // Foundation
import MyListsDetailsPageTypeLink from "@insite/content-library/Components/MyListsDetailsPageTypeLink";
// import WishListSharingStatus, {
//     WishListSharingStatusStyles,
// } from "@insite/content-library/Components/WishListSharingStatus"; // Foundation
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Foundation
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import Icon, { IconPresentationProps } from "@insite/mobius/Icon"; // Foundation
import Star from "@insite/mobius/Icons/Star";
import StarX from "@insite/mobius/Icons/StarX";
import Tag from "@insite/mobius/Icons/Tag";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
// import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip"; // Starter Custom Code
import Typography, { TypographyProps } from "@insite/mobius/Typography";
// import React, { useContext } from "react"; Foundation
import { connect, HandleThunkActionCreator } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import StarFill from "@store/Library/Components/Toolkit/Icons/Star/StarFill";
import StarLine from "@store/Library/Components/Toolkit/Icons/Star/StarLine";
import TagLine from "@store/Library/Components/Toolkit/Icons/Tag/TagLine";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import { imageStyles } from "@store/Themes/common/mixins/image";
// import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { productLineProps } from "@store/Themes/common/props/productLine";
import {
    tableGetEllipsisCellProps,
    tableProps,
    tableRemoveEllipsisCellProps,
} from "@store/Themes/common/props/table";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins/common";

// Foundation --->
import StoreAddToCartRestrictionsMessage from "@store/Library/Components/Foundation/StoreAddToCartRestrictionsMessage";
import Trash2Fill from "@store/Library/Components/Icons/Trash2/Trash2Fill";
import WishListSharingStatus, {
    WishListSharingStatusStyles,
} from "@store/Overrides/Components/WishListSharingStatus";
import { ellipsis } from "@store/Themes/common/mixins/ellipsis";
import { productLineProps as storeProductLineProps } from "@store/Themes/common/props/productLine";
import { productTableProps } from "@store/Themes/common/props/productTable";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import Icon, { IconMemo, IconPresentationProps, IconProps } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import TwoButtonModal, { TwoButtonModalStyles } from "@store/Overrides/Components/TwoButtonModal";
import React, { useContext, useState } from "react";
// <--- Foundation

const getIconProps = (src?: IconPresentationProps["src"]) => {
    return {
        src,
        size: 20,
        color: "primary", // Foundation
    };
};

const actionClickable = () => css`
    ${focusStyles(true)};
    padding: ${pxToRem(10)};
`;
/* Starter Custom Code - End */
const mapStateToProps = (state: ApplicationState, ownProps: OwnProps /* Foundation */) => ({
    language: state.context.session.language,
    allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
    isUpdatingCart: state.context.isUpdatingCart,
    // Foundation
    restrictedLines:
        getWishListLinesDataView(state, { wishListId: ownProps.wishList.id }).value?.filter(x => !x.canAddToCart) || [],
});

interface OwnProps {
    wishList: WishListModel;
    extendedStyles?: WishListCardStyles;
    addWishListToCart: HandleThunkActionCreator<typeof addWishListToCart>;
    deleteWishList?: () => void;
    leaveWishList?: () => void;
    toggleFavorite?: () => void;
    toggleHide?: () => void;
    // Starter Custom Code
    showFavorites?: boolean;
    showTags?: boolean;
    // Foundation
    showDescription?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface WishListCardStyles {
    gridContainer?: GridContainerProps;
    wishListInfoGridItem?: GridItemProps;
    wishListInfoGridContainer?: GridContainerProps;
    basicInfoGridItem?: GridItemProps;
    basicInfoGridContainer?: GridContainerProps;
    detailLinkGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyProps;
    lastUpdatedGridItem?: GridItemProps;
    lastUpdatedText?: TypographyProps;
    extendedInfoGridItem?: GridItemProps;
    extendedInfoGridContainer?: GridContainerProps;
    productImagesGridItem?: GridItemProps;
    productImageLink?: LinkPresentationProps;
    productImage?: LazyImageProps;
    sharingStatusGridItem?: GridItemProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionGridItem?: GridItemProps;
    actionGridMediumHidden?: HiddenProps;
    actionOverflowIcon?: IconPresentationProps;
    actionOverflowMenu?: OverflowMenuPresentationProps;
    actionAddToCartClickable?: ClickablePresentationProps;
    actionHideClickable?: ClickablePresentationProps;
    actionDeleteClickable?: ClickablePresentationProps;
    actionLeaveClickable?: ClickablePresentationProps;
    actionAddToCartButton?: ButtonPresentationProps;
    actionHideLink?: LinkPresentationProps;
    actionDeleteButton?: ButtonPresentationProps;
    actionLeaveButton?: ButtonPresentationProps;
    actionFavoriteClickable?: ClickablePresentationProps;
    basicIconGridContainer?: GridContainerProps;
    detailIconGridItem?: GridItemProps;
    starIcon?: IconPresentationProps;
    starXIcon?: IconPresentationProps;
    tagTooltip?: TooltipPresentationProps;
    // Starter Custom Code
    iconCell?: DataTableCellProps;
    listNameDescriptionCell?: DataTableCellProps;
    dateCell?: DataTableCellProps;
    statusCell?: DataTableCellProps;
    itemsCell?: DataTableCellProps;
    itemsWrapper?: InjectableCss;
    itemsImageWrapper?: InjectableCss;
    itemProductImage?: ProductImageStyles;
    actionsCell?: DataTableCellProps;
    actionsWrapper?: InjectableCss;
    actionAddToCartLink?: LinkPresentationProps;
    actionLeaveLink?: LinkPresentationProps;
    actionDeleteLink?: LinkPresentationProps;
    actionUnhideLink?: LinkPresentationProps;
    // Foundation
    tableCellDescription?: DataTableCellProps;
    tableCellActions?: DataTableCellProps;
    tableCellActionsWrapper?: InjectableCss;
    tableCellProducts?: InjectableCss;
    tableCellProductsWrapper?: InjectableCss;
    addButton?: ButtonProps;
    trashIcon?: IconProps;
    linkWrappingImage?: InjectableCss;
    tableCellTitle?: DataTableCellProps;
    obsoleteListItemsModal?: TwoButtonModalStyles;
    removeListLineIcon?: IconPresentationProps;
}

export const wishListCardStyles: WishListCardStyles = {
    iconCell: {
        css: css`
            padding: 0;
        `,
    },
    gridContainer: {
        gap: 5,
    },
    wishListInfoGridItem: {
        width: [10, 10, 8, 10, 10],
        align: "middle",
    },
    basicInfoGridItem: { width: [12, 12, 5, 4, 4] },
    basicInfoGridContainer: {
        gap: 10,
    },
    detailLinkGridItem: { width: 12 },
    descriptionGridItem: { width: 12 },
    lastUpdatedGridItem: { width: 12 },
    extendedInfoGridItem: {
        width: [12, 12, 7, 8, 8],
        align: "middle",
    },
    productImageLink: {
        css: css`
            ${({ theme }) => imageStyles(theme.design.product.image.medium.ratio)}
            width: ${pxToRem(65)};
        `,
    },
    productImagesGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            flex-wrap: wrap;
        `,
    },
    productImage: {
        css: css`
            max-width: ${pxToRem(75)};
            img {
                height: 100%;
            }
        `,
        errorTypographyProps: {
            size: 11,
            css: css`
                max-height: ${pxToRem(65)};
            `,
        },
    },
    sharingStatusGridItem: { width: [12, 12, 12, 4, 4] },
    sharingStatus: {
        privateTooltip: {
            cssOverrides: {
                tooltipWrapper: css`
                    margin-left: 0.25em;
                `,
            },
        },
        statusText: {
            css: css`
                display: flex;
                align-items: center;
                > span {
                    ${ellipsis(pxToRem(150))}
                }
            `,
        },
    },
    actionGridItem: {
        width: [2, 2, 4, 2, 2],
        align: "top",
        css: css`
            justify-content: flex-end;
        `,
    },
    actionGridMediumHidden: {
        css: css`
            width: 100%;
        `,
    },
    actionAddToCartButton: {
        css: css`
            ${({ theme }) => theme?.button?.primary?.css}
            min-width: 0;
            padding: 0 ${pxToRem(15)};
            margin-right: 0.5em;
        `,
    },
    actionDeleteButton: {
        color: "danger.light",
        css: css`
            ${({ theme }) => theme?.button?.defaultProps?.css}
            margin-left: ${pxToRem(5)};
            min-width: 0;
            padding: 0 ${pxToRem(5)};
        `,
    },
    actionLeaveButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin-top: ${pxToRem(10)};
        `,
    },
    tableCellDescription: {
        css: css`
            ${productTableProps.tableCellDescription?.css}
            ${ellipsis(pxToRem(150))}
        `,
    },
    tableCellActions: productTableProps.tableCellControls,
    tableCellActionsWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    tableCellProducts: productTableProps.tableCellControls,
    tableCellProductsWrapper: {
        css: css`
            display: flex;
        `,
    },
    trashIcon: {
        src: Trash2Fill,
        color: "danger",
    },
    linkWrappingImage: {
        css: css`
            position: relative;
            margin-right: ${pxToRem(5)};
        `,
    },
    tableCellTitle: {
        css: css`
            ${TypographyStyle} {
                ${ellipsis(pxToRem(150))}
            }
        `,
    },
    removeListLineIcon: storeProductLineProps.removeProductLineIcon,
    actionLeaveLink: productLineProps.leaveLink,
    actionDeleteLink: productLineProps.removeLink,
    actionHideLink: productLineProps.hideLink,
    actionUnhideLink: productLineProps.unhideLink,
    actionFavoriteClickable: {
        css: css`
            ${actionClickable()}
        `,
    },
    starIcon: getIconProps(StarLine),
    starXIcon: getIconProps(StarFill),
    tagTooltip: {
        iconProps: getIconProps(TagLine),
        cssOverrides: {
            tooltipContainer: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipContainer}
                bottom: 80%;
                left: 5px;
                justify-content: flex-start;
                transform: none;
            `,
            tooltipArrow: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipArrow}
                left: 7%;
            `,
            tooltipWrapper: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipWrapper}
                margin-left: 0;
            `,
            tooltipClickable: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipClickable}
                ${actionClickable()}
            `,
        },
    },
};

const WishListCard = ({
    language,
    allowEditingOfWishLists,
    isUpdatingCart,
    extendedStyles,
    wishList,
    addWishListToCart,
    deleteWishList,
    leaveWishList,
    toggleFavorite,
    toggleHide,
    // Starter Custom Code
    showFavorites,
    showTags,
    // Foundation
    restrictedLines,
    showDescription,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const isLoadingAnyList = useAppSelector(state => Object.keys(state.data.wishLists.isLoading).length > 0);

    // Foundation --->
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    // <--- Foundation
    /* Starter Custom Code - Start */
    const trackAddWishListToCart = ga.use.trackAddWishListToCart({}, { wishList });
    const trackAddToCart = ga.use.trackAddToCart({}, { wishList });
    /* Starter Custom Code - End */

    const clickAddToCartHandler = (e: any, hasConfirm = false /* Foundation */) => {
        e.preventDefault();

        /* Foundation ---> */
        if (restrictedLines.length && !hasConfirm) {
            setConfirmModalIsOpen(true);
            return;
        }
        /* <--- Foundation */

        addWishListToCart({
            apiParameter: { wishListId: wishList.id },
            onSuccess: onAddAllToCartSuccess,
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    };

    /* Foundation ---> */
    const addToCartCancelHandler = () => {
        setConfirmModalIsOpen(false);
    };
    const addToCartSubmitHandler = (e: any) => {
        setConfirmModalIsOpen(false);
        clickAddToCartHandler(e, true);
    };
    /* <--- Foundation */

    const onAddAllToCartSuccess = (result: CartLineCollectionModel) => {
        /* Starter Custom Code - Start */
        trackAddWishListToCart();
        trackAddToCart();
        /* Starter Custom Code - End */
        toasterContext.addToast({
            body: result.notAllAddedToCart
                ? siteMessage("Lists_Items_Not_All_Added_To_Cart")
                : translate("List Added to Cart"),
            messageType: "success",
        });
    };

    const updatedOnDisplay = getLocalizedDateTime({
        dateTime: new Date(wishList.updatedOn),
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    /* Starter Custom Code - Start */
    const lastUpdatedDisplay =
        wishList.updatedByDisplayName && !wishList.isAutogenerated
            ? ` ${translate("by")} ${wishList.updatedByDisplayName}`
            : null;
    /* Starter Custom Code - End */

    const styles = useMergeProps(wishListCardStyles, extendedStyles); // Starter Custom Code
    const canAddToCart = wishList.canAddToCart && !!wishList.wishListLinesCount && wishList.wishListLinesCount > 0;
    const addToCartLabel = translate("Add List to Cart");
    const toggleHideButtonText = wishList.isHidden ? translate("Unhide List") : translate("Hide List");
    const toggleHideButtonStyles = wishList.isHidden ? styles.actionUnhideLink : styles.actionHideLink; // Starter Custom Code
    const deleteLabel = translate("Delete");
    const leaveLabel = translate("Leave List");

    /* Starter Custom Code - Start */
    const statusCellStyles = React.useMemo(() => {
        if (wishList?.isSharedList || wishList?.wishListSharesCount) {
            return styles.statusCell;
        }

        return mergeProps<typeof styles.statusCell>(styles.statusCell, tableRemoveEllipsisCellProps());
    }, [styles.statusCell, wishList?.isSharedList, wishList?.wishListSharesCount]);

    const tagsText = translate("View Tags Assigned");
    /* Starter Custom Code - End */

    return (
        // Foundation --->
        <DataTableRow data-test-selector="wishListCard">
            <DataTableCell {...styles.tableCellTitle}>
                <MyListsDetailsPageTypeLink
                    title={wishList.name}
                    wishListId={wishList.id}
                    testSelector="wishListCardName"
                />
            </DataTableCell>
            {showDescription && (
                <DataTableCell {...styles.tableCellDescription}>
                    <Typography {...styles.descriptionText} data-test-selector="wishListCardDescription">
                        {wishList?.description ?? ""}
                    </Typography>
                </DataTableCell>
            )}
            <DataTableCell>
                <Typography {...styles.lastUpdatedText} data-test-selector="wishListCardLastUpdated">
                    {updatedOnDisplay}
                </Typography>
                {lastUpdatedDisplay ? (
                    <Typography {...styles.lastUpdatedText} data-test-selector="wishListCardLastUpdated">
                        {lastUpdatedDisplay}
                    </Typography>
                ) : null}
            </DataTableCell>
            <DataTableCell {...styles.tableCellProducts}>
                <StyledWrapper {...styles.tableCellProductsWrapper}>
                    {wishList.wishListLineCollection &&
                        wishList.wishListLineCollection.length > 0 &&
                        wishList.wishListLineCollection.slice(0, 1).map(line => (
                            <StyledWrapper key={line.id.toString()} {...styles.linkWrappingImage}>
                                <Link {...styles.productImageLink} href={line.productUri}>
                                    <LazyImage
                                        {...styles.productImage}
                                        src={line.smallImagePath}
                                        altText={line.altText}
                                    />
                                </Link>
                            </StyledWrapper>
                        ))}
                </StyledWrapper>
            </DataTableCell>
            <DataTableCell>
                <WishListSharingStatus removeTooltip extendedStyles={styles.sharingStatus} wishList={wishList} />
            </DataTableCell>
            <DataTableCell {...styles.tableCellActions}>
                <StyledWrapper {...styles.tableCellActionsWrapper}>
                    <Button
                        {...styles.actionAddToCartButton}
                        disabled={!canAddToCart || isUpdatingCart}
                        data-test-selector={`wishListAddToCartButton_${wishList.id}`}
                        onClick={clickAddToCartHandler}
                    >
                        {addToCartLabel}
                    </Button>
                    {/* Foundation ---> */}
                    <Clickable
                        disabled={
                            !deleteWishList ||
                            wishList.isSharedList ||
                            !allowEditingOfWishLists ||
                            wishList.isAutogenerated
                        }
                        onClick={deleteWishList}
                        data-test-selector={`wishListCardDeleteButton_${wishList.id}`}
                    >
                        <IconMemo {...styles.removeListLineIcon} />
                        <VisuallyHidden>{translate("Delete this wishlist")}</VisuallyHidden>
                    </Clickable>
                    {/* <--- Foundation */}
                    {/* Foundation Removed - LeaveButton */}
                </StyledWrapper>
                {/* Foundation ---> */}
                <TwoButtonModal
                    headlineText={translate("Add to Cart")}
                    modalIsOpen={confirmModalIsOpen}
                    messageText={
                        <StoreAddToCartRestrictionsMessage list={restrictedLines.map(x => x.shortDescription)} />
                    }
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Continue")}
                    onCancel={addToCartCancelHandler}
                    onSubmit={addToCartSubmitHandler}
                />
                {/* <--- Foundation */}
            </DataTableCell>
        </DataTableRow>
        // <--- Foundation
    );
};

export default connect(mapStateToProps)(WishListCard);
